export default "__VITE_ASSET__yQ3tLW9z__"